$(document).ready(function(){
    // Share
    $('.share').click(function(){
        $('.share-items').slideToggle();
        $(this).toggleClass('active');
        return false;
    });	
});		



// WEBPACK FOOTER //
// ./src/js/share.js